import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { organizationAccountIconMap } from 'src/app/constants/org-account-icon-map';

@Component({
  selector: 'app-organization-account-details',
  templateUrl: './organization-account-details.component.html',
  styleUrls: ['./organization-account-details.component.scss'],
})
export class OrganizationAccountDetailsComponent {
  @Input() data: any;
  @Input() ref: any;
  accountIconMap = organizationAccountIconMap;
  constructor(private route: ActivatedRoute, private router: Router) {}

  goToStack(stack, ref) {
    ref.close();
    const url = '/stack/' + stack.stackName;
    this.router.navigate([url]);
  }

  goToEnv(env, ref) {
    ref.close();
    const url =
      '/stack/' + env.stackName + '/dialog/cluster/' + env.id + '/overview-v2';
    this.router.navigate([url]);
  }
}
